import { Cancel, Save } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../../api2";
import Helper from "../../../helpers";
import { commonReducerSelector, userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import { FormNhap } from "./form";
import { parseDataSave, propsToInitialState } from "./models";

const RoutesQuanLyTinTuc = [
  {
    path: "",
    main: () => <QuanLyTinTuc />
  },
  {
    path: "add",
    main: () => <HandleQuanLyTinTuc />
  },
  {
    path: "edit/:id",
    main: () => <HandleQuanLyTinTuc />
  }
];
export default RoutesQuanLyTinTuc;

function QuanLyTinTuc() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const [chuyenMucList, setChuyenMucList] = useState([]);
  const formikRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
    if (isEmpty(chuyenMucList)) {
      new Api().GetChuyenMucs({}).then(data => {
        if (data.code === 200) {
          setChuyenMucList(data?.data);
        }
      });
    }
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListQuanLyTinTuc({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      { headerName: "Tiêu đề", field: "tieuDe", width: "400px" },
      {
        headerName: "Chuyên mục",
        field: "chuyenMuc",
        width: "200px",
        cellRendererFramework: params => {
          let returnData = null;
          if (params?.data?.idChuyenMuc) {
            returnData = chuyenMucList?.find(
              item => item?.id === params.data.idChuyenMuc
            )?.tenChuyenMuc;
          }
          return returnData;
        }
      },
      {
        headerName: "Hiển thị",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRendererFramework: params => {
          let returnStatus = (
            <div className="tableList-button-ngungHoatDong">Không hiển thị</div>
          );
          if (params?.data?.hienThi) {
            returnStatus = (
              <div className="tableList-button-dangHoatDong">Đang hiển thị</div>
            );
          }
          return returnStatus;
        }
      },
      {
        headerName: "Tin nổi bật",
        minWidth: 200,
        flex: 1,
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRendererFramework: params => {
          let returnStatus = (
            <div className="tableList-button-ngungHoatDong">Không nổi bật</div>
          );
          if (params?.data?.tin_NoiBat) {
            returnStatus = (
              <div className="tableList-button-dangHoatDong">Nổi bật</div>
            );
          }
          return returnStatus;
        }
      },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteQuanLyTinTucById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => {});
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs
        title={[{ name: "Quản trị hệ thống" }, { name: "Quản lý tin tức" }]}
      />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
    </div>
  );
}

function HandleQuanLyTinTuc() {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const [chuyenMucList, setChuyenMucList] = useState([]);
  const dataDanhMuc = common?.danhmucs?.data;
  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetQuanLyTinTucById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(chuyenMucList)) {
      new Api().GetChuyenMucs({}).then(data => {
        if (data.code === 200) {
          setChuyenMucList(data?.data);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(data, chuyenMucList);

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
            chuyenMucList={chuyenMucList}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }
    new Api()
      .UpsertQuanLyTinTuc({
        token: user.access_token,
        data: parseDataSave(formRef.current.values)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          ThongBao({
            status: "error",
            message: "Đã tồn tại bản ghi với vị trí này!"
          });
          return;
        }
        ThongBao({ status: "success", message: res?.data });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Quản trị hệ thống" },
            { name: "Quản lý tin tức", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={() => {
            handleSave();
          }}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
